/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Meta_PageInputs */

const ja_calendar_meta_page = /** @type {(inputs: Calendar_Meta_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`calendar`)
};

const en_calendar_meta_page = /** @type {(inputs: Calendar_Meta_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`calendar`)
};

/**
* | output |
* | --- |
* | "calendar" |
*
* @param {Calendar_Meta_PageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_meta_page = /** @type {((inputs?: Calendar_Meta_PageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Meta_PageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_calendar_meta_page(inputs)
	return en_calendar_meta_page(inputs)
});